import { Box } from "@mui/material";
import RegisterForm from "../organisms/RegisterForm";
import MainTemplate from "../templates/MainTemplate";
import useBreakpoint from "../../hooks/useBreakpoint";

export default function RegisterPage() {
  const breakpoint = useBreakpoint();
  return (
    <MainTemplate>
      <Box
        py={8}
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
      >
        <img
          style={{
            position: "absolute",
            height: 1200,
            width: 1200,
            left: -600,
            bottom: -200,
          }}
          src={require("../../assets/grey-circles.png")}
        />
        <img
          style={{
            position: "absolute",
            height: 1200,
            width: 1200,
            right: -200,
            top: -200,
          }}
          src={require("../../assets/blue-circles.png")}
        />
        <Box ml={breakpoint.md ? 20 : 0} zIndex={2} position="relative">
          {breakpoint.md && (
            <img
              style={{
                position: "absolute",
                height: 610,
                objectFit: "cover",
                top: 100,
                left: -380,
                zIndex: 3,
              }}
              src={require("../../assets/girl-sitting.png")}
            />
          )}
          <RegisterForm />
        </Box>
      </Box>
    </MainTemplate>
  );
}
